import { render, staticRenderFns } from "./BaseTableCell.vue?vue&type=template&id=23fd18b6&scoped=true&lang=pug&"
import script from "./BaseTableCell.vue?vue&type=script&lang=js&"
export * from "./BaseTableCell.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableCell.vue?vue&type=style&index=0&id=23fd18b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd18b6",
  null
  
)

export default component.exports